module.exports = __webpack_public_path__ + "img/3.6052e353.jpg";